import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalTables } from '../../../models'
import { daMetricHeaders } from './da-metric-headers'

export const daProductMetricHeaders: Array<TGlobalTables> =
  daMetricHeaders.filter(
    (header) =>
      !(
        header === EReportColumnHeader.ShareOfVoice ||
        header === EReportColumnHeader.WinRate ||
        header === EReportColumnHeader.AvgRank ||
        header === EReportColumnHeader.Frequency
      )
  )
